<div class="card card1">
    <div class="p-fluid p-formgrid grid justify-content-start">
        <div class="field col-12 md:col-3">
            <label htmlFor="selectUserType">{{'USER_TYPE'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userTypeList" [(ngModel)]="selectedUserType" (onChange)="onChangeUserType()"
                    placeholder="{{'Select User Type'| translate}}" optionLabel="Level_Id"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectUserAction">{{'USER_ACTION'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userActionList" [(ngModel)]="selectedUserAction" (onChange)="onChangeUserAction()"
                placeholder="{{'Select User Action'| translate}}" optionLabel="Action_Type"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectUserId">{{'USER_ID'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userIdList" [(ngModel)]="selectedUserId" (onChange)="onChangeUserIdList()"
                    placeholder="{{'Select User Id'| translate}}" optionLabel="UserId"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label>{{'FINANCIAL_YEAR'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="finYearList" [(ngModel)]="selectedFinYear" (onChange)="onChangeFinYear()"
                    placeholder="{{'SELECT_FINANCIAL_YEAR'| translate}}" optionLabel="FinancialYears" optionValue="FinancialYears"></p-dropdown>
            </div>
        </div>
    </div>

</div>
<div class="card dashboardTable mt-2" *ngIf="showTableData">
    <p-table #allFarmerApps [value]="tableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'AppID',
            'FarmerName',
            'AppUserType',
            'ApplicantType',
            'Caste_Description',
            'Program',
            'FinYear',
            'District',
            'Block',
            'Village',
            'Scheme',
            'AssignedDate'
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                <!-- Left side -->
                <div class="col-12 md:col-8">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ tableHeaderName | translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-0 md:col-0 d-flex justify-content-center">
                   
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="allFarmerApps.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="exportMenu"></p-menu> -->
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'VIEW_APPLICATION'| translate}}</th>
                <!-- <th>{{'S_NO'| translate}}</th> -->
                <!-- <th pSortableColumn="APP_ID">{{'APP_ID'| translate}}</th> -->
                <!-- <th pSortableColumn="FarmerStatus_Description">{{'STATUS'| translate}}
                    <p-columnFilter type="text" field="FarmerStatus_Description" display="menu"></p-columnFilter>
                </th> -->
                <th>{{'APP_ID'| translate}}</th>
                <th>{{'FARMER_NAME'| translate}}</th>
                <th>{{'USER_TYPE'| translate}}</th>
                <th>{{'APPLICANT_TYPE'| translate}}</th>
                <th>{{'CASTE'| translate}}</th>
                <th>{{'ASSIGNED_DATE'| translate}}</th>
                <!-- <th *ngIf="selectedUserType?.Type == 'MI'">{{'PROGRAMME_NAME'| translate}}</th> -->
                <!-- <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}</th> -->
                <th>{{'DISTRICT'| translate}}</th>
                <th>{{'BLOCK'| translate}}</th>
                <th>{{'VILLAGE'| translate}}</th>
                <!-- <th>{{'SCHEME'| translate}}</th> -->
                <th>{{'FINANCIAL_YEAR'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-val let-ri="rowIndex">
            <tr class="body-section">
            <!-- <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}"> -->
                <!-- <td>{{ ri + 1 }}</td> -->
                <!-- <td class="clickable" (click)="selectFarmerApplication(val)">{{val?.APP_ID}}</td> -->
                <!-- <td>{{val?.FarmerStatus_Description }}</td> -->
                <td>
                    <button pButton pRipple pTooltip="View Application" icon="pi pi-file"
                    class="p-button-rounded p-button-accent p-button-secondary p-button-sm"
                    (click)="printForm(val?.AppID ? val?.AppID : val?.appID, 'pending')"></button>
                </td>
                <td>{{val?.AppID ? val?.AppID : val?.appID}}</td>
                <td>{{val?.FarmerName}}</td>
                <td>{{val?.AppUserType ? val?.AppUserType : val?.UserType }}</td>
                <td>{{val?.ApplicantType ? val?.ApplicantType : val?.Applicant_type }}</td>
                <td>{{val?.Caste_Description}}</td>
                <td>{{val?.AssignedDate != ('' || null) ? (val?.AssignedDate | date:'mediumDate') : val?.AssignedDate }}</td>
                <!-- <td *ngIf="selectedUserType?.Type == 'MI'">{{val?.Program}}</td> -->
                <!-- <td>{{val?.Constituency}}</td> -->
                <td>{{val?.District ? val?.District : val?.district }}</td>
                <td>{{val?.Block ? val?.Block: val?.block }}</td>
                <td>{{val?.Village ? val?.Village : val?.village }}</td>
                <!-- <td>{{selectedUserType?.Type}}</td> -->
                <td>{{val?.FinYear}}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tableData ?
                    tableData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                </p>
                <!-- <div class="flex  justify-content-between flex-column "> 
                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APPROVED' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffffc5 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'RETUREN_PROCESS' | translate}}</div>
                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'REJECTED' | translate}}</div>
                </div> -->
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>

    </p-table>
</div>